import { render, staticRenderFns } from "./Report-student.vue?vue&type=template&id=30157bad&"
import script from "./Report-student.vue?vue&type=script&lang=js&"
export * from "./Report-student.vue?vue&type=script&lang=js&"
import style0 from "./Report-student.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Report-student.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports